import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setInversiones = info => {
	return {
		type: ActionTypes.LOAD_INVERSIONES,
		inversiones: info.data
	};
};
/*
export const onUpdateInformativeText = response => {
	return {
		type: ActionTypes.MODIFY_INFORMATIVETEXT,
		response: response
	};
};
*/

export const loadInversiones = () => {
	return dispatch => {
		axios
			.get("https://getupstudio.co/solanasapi/inversiones")
			.then(response => {
				dispatch(setInversiones(response.data));
			})
			.catch(error => {});
	};
};

export const saveInversion = (inversion) => {

	console.log(inversion);

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/inversiones/edit",
				inversion
			)
			.then(response => {
				dispatch(loadInversiones());
			})
			.catch(error => {});
	};
};
